import { FileLikeObject } from "ng2-file-upload";

export class CustomFileLike extends FileLikeObject {
    public documentType: string;
    public file: File;
    public description: string;
}